import { useEffect, useState } from "react";
import api from "../../api";
import { ServerHealth } from "../../utils/diagnostico";

const POLL_INTERVAL_MS = 2 * 60 * 1000;

const MENSAGEM: Record<Exclude<ServerHealth, "Normal">, string> = {
  Degraded:
    "⚠️ Estamos com lentidão no nosso servidor neste momento. Nossa equipe já está trabalhando para normalizar.",
  Down: "⚠️ Nosso servidor está instável neste momento. Nossa equipe já está trabalhando para normalizar.",
};

const ServerStatusBanner = () => {
  const [status, setStatus] = useState<ServerHealth>("Normal");

  useEffect(() => {
    let ativo = true;

    async function verificar() {
      try {
        const response = await api.get("/Diagnostico/status");
        if (ativo) setStatus(response.data.status as ServerHealth);
      } catch {
        if (ativo) setStatus("Normal");
      }
    }

    verificar();
    const intervalo = setInterval(verificar, POLL_INTERVAL_MS);
    return () => {
      ativo = false;
      clearInterval(intervalo);
    };
  }, []);

  if (status === "Normal") return null;

  return (
    <div
      style={{
        backgroundColor: "#fb6340",
        color: "#FFF",
        textAlign: "center",
        padding: "10px 16px",
        fontWeight: 600,
      }}
    >
      {MENSAGEM[status]}
    </div>
  );
};

export default ServerStatusBanner;
